import type { Ref } from 'vue'

interface UseCapturedUtmSource {
  capturedUtmSource: Readonly<Ref<string | undefined>>
}

export function useCapturedUtmSource(): UseCapturedUtmSource {
  const captured = useState<string | undefined>(
    'capturedUtmSource',
    () => undefined
  )
  const route = useRoute()

  onMounted(() => {
    if (captured.value) return
    const raw = route.query.utm_source
    const value = Array.isArray(raw) ? raw[0] : raw
    if (typeof value === 'string' && value) {
      captured.value = value
    }
  })

  return { capturedUtmSource: readonly(captured) }
}
